<!-- 关于我们页面 -->
<template>
  <div class="about-container">
    <!-- Hero Banner -->
    <section class="about-hero">
      <img
        class="hero-bg"
        :src="$i18n.locale === 'zh' ? require('../../assets/img/关于我们头banner.webp') : require('../../assets/img/关于我们（英）.webp')"
        alt=""
      />
    </section>

    <!-- Company Intro -->
    <section class="intro-section">
      <div class="intro-grid">
        <div class="intro-text">
          <div class="section-label">{{ $i18n.locale === 'zh' ? '公司简介' : 'Company Profile' }}</div>
          <h2 class="section-title">{{ $i18n.locale === 'zh' ? '用心服务，确保成果' : 'Work with dedication, ensure results' }}</h2>
          <p class="intro-p">{{ $t('about.p1') }}</p>
          <p class="intro-p">{{ $t('about.p2') }}</p>
          <p class="intro-p">{{ $t('about.p3') }}</p>
        </div>
        <div class="intro-stats">
          <div class="stat-card" v-for="(stat, i) in companyStats" :key="i">
            <span class="stat-icon">{{ stat.icon }}</span>
            <span class="stat-value">
              <template v-if="i === 0">{{ yearsSince }}</template>
              <template v-else>{{ animatedStats[i - 1] }}{{ stat.suffix }}</template>
            </span>
            <span class="stat-label">{{ stat.label }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Core Competencies -->
    <section class="competencies-section">
      <div class="section-label center">{{ $i18n.locale === 'zh' ? '核心能力' : 'Core Competencies' }}</div>
      <h2 class="section-title center">{{ $i18n.locale === 'zh' ? '一站式汽车技术服务' : 'One-Stop Automotive Technical Services' }}</h2>
      <div class="comp-grid">
        <div class="comp-card" v-for="(item, i) in competencies" :key="i">
          <div class="comp-icon">{{ item.icon }}</div>
          <h3 class="comp-title">{{ item.title }}</h3>
          <p class="comp-desc">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <!-- Honors & Certificates -->
    <section class="honors-section">
      <div class="section-label center">{{ $i18n.locale === 'zh' ? '荣誉资质' : 'Honors & Certificates' }}</div>
      <h2 class="section-title center">{{ $i18n.locale === 'zh' ? '行业认可，值得信赖' : 'Industry Recognized, Trustworthy' }}</h2>

      <!-- Patent Banner -->
      <div class="patent-banner">
        <img
          :src="$i18n.locale === 'zh' ? require('../../assets/img/关于我们-荣誉.webp') : require('../../assets/img/关于我们-2（英）.webp')"
          alt=""
        />
      </div>

      <!-- Certificate Gallery floating over data banner -->
      <div class="cert-overlay-section">
        <h3 class="gallery-title">{{ $i18n.locale === 'zh' ? '资质证书' : 'Certificates' }}</h3>
        <div class="cert-overlay-wrapper">
          <img
            class="cert-bg"
            :src="$i18n.locale === 'zh' ? require('../../assets/img/关于我们-中_画板_1.webp') : require('../../assets/img/关于我们-3（英）.webp')"
            alt=""
          />
          <div class="cert-overlay-grid">
            <div class="cert-row" v-for="(row, ri) in certRows" :key="ri">
              <div
                class="cert-item"
                v-for="(img, ci) in row"
                :key="ci"
                @click="openCertPreview(ri * 3 + ci)"
              >
                <img :src="img.thumb" class="cert-thumb" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Certificate Lightbox -->
    <div class="cert-lightbox" v-if="certViewerVisible" @click="certViewerVisible = false"
      @touchstart="onTouchStart" @touchend="onTouchEnd">
      <div class="cert-lightbox-mask"></div>
      <div class="cert-lightbox-body" @click.stop>
        <button class="cert-lightbox-close" @click="certViewerVisible = false">✕</button>
        <button class="cert-lightbox-arrow cert-lightbox-prev" @click.stop="prevCert" v-if="certViewerIndex > 0">
          <span>‹</span>
        </button>
        <img :src="allFullImages[certViewerIndex]" alt="" class="cert-lightbox-img" />
        <button class="cert-lightbox-arrow cert-lightbox-next" @click.stop="nextCert" v-if="certViewerIndex < allFullImages.length - 1">
          <span>›</span>
        </button>
        <span class="cert-lightbox-counter">{{ certViewerIndex + 1 }} / {{ allFullImages.length }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.$t('about.seoTitle'),
      meta: [
        { name: "description", content: this.$t('about.seoDescription') },
        { name: "keywords", content: this.$t('about.seoKeywords') },
      ],
    }
  },
  data() {
    return {
      animatedStats: [0, 0, 0],
      certViewerVisible: false,
      certViewerIndex: 0,
      touchStartX: 0,
      img_datas1: [
        require('@/assets/img/B关于我们/1-1.webp'),
        require('@/assets/img/B关于我们/2-1.webp'),
        require('@/assets/img/B关于我们/3-1.webp'),
      ],
      img_datas2: [
        require('@/assets/img/B关于我们/4-1.webp'),
        require('@/assets/img/B关于我们/5-1.webp'),
        require('@/assets/img/B关于我们/6-1.webp'),
      ],
      srcList1: [
        require('@/assets/img/B关于我们/1.webp'),
        require('@/assets/img/B关于我们/2.webp'),
        require('@/assets/img/B关于我们/3.webp'),
      ],
      srcList2: [
        require('@/assets/img/B关于我们/4.webp'),
        require('@/assets/img/B关于我们/5.webp'),
        require('@/assets/img/B关于我们/6.webp'),
      ],
    };
  },
  computed: {
    yearsSince() {
      return new Date().getFullYear() - 2008;
    },
    certRows() {
      const certs = [];
      for (let i = 0; i < 3; i++) {
        certs.push({ thumb: this.img_datas1[i], full: this.srcList1[i] });
      }
      for (let i = 0; i < 3; i++) {
        certs.push({ thumb: this.img_datas2[i], full: this.srcList2[i] });
      }
      return [certs.slice(0, 3), certs.slice(3, 6)];
    },
    allFullImages() {
      return [...this.srcList1, ...this.srcList2];
    },
    companyStats() {
      return this.$i18n.locale === 'zh' ? [
        { icon: '', label: '年行业深耕', suffix: '' },
        { icon: '', label: '项专利与软著', suffix: '+' },
        { icon: '', label: '累计服务项目', suffix: '+' },
        { icon: '', label: '年 ISO 9001 认证', suffix: '' },
      ] : [
        { icon: '', label: 'Years of Excellence', suffix: '' },
        { icon: '', label: 'Patents & Copyrights', suffix: '+' },
        { icon: '', label: 'Projects Delivered', suffix: '+' },
        { icon: '', label: 'Years ISO 9001 Certified', suffix: '' },
      ];
    },
    competencies() {
      return this.$i18n.locale === 'zh' ? [
        { icon: '', title: '技术文档开发', desc: '用户手册、维修手册、电路图册、诊断手册、备件目录、工时手册等全套售后技术文档' },
        { icon: '', title: '专用工具研制', desc: '汽车维修专用工具的设计开发、生产制造，提供定制化解决方案' },
        { icon: '', title: '培训教具开发', desc: '培训教材、教学展具、3D仿真培训系统、VR/AR教学应用开发' },
        { icon: '', title: '软件平台搭建', desc: '维修技术信息系统、H5平台、手机APP等数字化售后服务解决方案' },
        { icon: '', title: '多媒体制作', desc: '汽车CG动画、教学视频拍摄与后期制作、三维模型开发' },
        { icon: '', title: '多语种翻译', desc: '提供英语、法语、西班牙语、俄语、阿拉伯语、葡萄牙语、日语等专业翻译服务' },
      ] : [
        { icon: '', title: 'Technical Documentation', desc: 'User manuals, maintenance manuals, wiring diagrams, diagnostic manuals, parts catalogs, labor time guides' },
        { icon: '', title: 'Specialty Tools R&D', desc: 'Design, development and manufacturing of automotive specialty tools with customized solutions' },
        { icon: '', title: 'Training Aids Development', desc: 'Training materials, teaching exhibits, 3D simulation systems, VR/AR teaching applications' },
        { icon: '', title: 'Software Platforms', desc: 'Repair technical information systems, H5 platforms, mobile apps for digital after-sales solutions' },
        { icon: '', title: 'Multimedia Production', desc: 'Automotive CG animation, instructional video production, 3D model development' },
        { icon: '', title: 'Multi-language Translation', desc: 'English, French, Spanish, Russian, Arabic, Portuguese, Japanese and more' },
      ];
    },
  },
  mounted() {
    document.dispatchEvent(new Event("render-event"));
    this.$nextTick(() => { this.animateStats(); });
  },
  watch: {
    '$i18n.locale'() {
      this.animatedStats = [0, 0, 0];
      this.$nextTick(() => { this.animateStats(); });
    },
  },
  methods: {
    openCertPreview(index) {
      this.certViewerIndex = index;
      this.certViewerVisible = true;
    },
    prevCert() {
      if (this.certViewerIndex > 0) this.certViewerIndex--;
    },
    nextCert() {
      if (this.certViewerIndex < this.allFullImages.length - 1) this.certViewerIndex++;
    },
    onTouchStart(e) {
      this.touchStartX = e.changedTouches[0].clientX;
    },
    onTouchEnd(e) {
      const dx = e.changedTouches[0].clientX - this.touchStartX;
      if (Math.abs(dx) > 50) {
        if (dx < 0) this.nextCert();
        else this.prevCert();
      }
    },
    animateStats() {
      // Animate: patents (skip first stat which is yearsSince), projects
      const targets = [
        this.$i18n.locale === 'zh' ? 20 : 20,   // patents
        this.$i18n.locale === 'zh' ? 200 : 200, // projects
        this.$i18n.locale === 'zh' ? 10 : 10,   // ISO years
      ];
      const duration = 1600;
      const startTime = performance.now();

      const step = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - (1 - progress) * (1 - progress);

        targets.forEach((target, i) => {
          this.$set(this.animatedStats, i, Math.round(target * eased));
        });

        if (progress < 1) {
          requestAnimationFrame(step);
        }
      };

      requestAnimationFrame(step);
    },
  },
};
</script>

<style lang="scss" scoped>
.about-container {
  width: 100%;
  min-width: auto;
  overflow-x: hidden;

  // ========== Shared ==========
  .section-label {
    display: inline-block;
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 3px;
    color: #d53434;
    margin-bottom: 12px;
    .lang-en & { font-size: 11px; letter-spacing: 2px; }
    &.center { display: block; text-align: center; }
  }
  .section-title {
    font-size: 32px;
    color: #1a1a1a;
    margin: 0 0 16px;
    font-weight: 700;
    line-height: 1.3;
    .lang-en & { font-size: 26px; }
    &.center { text-align: center; }
    @media (max-width: 768px) { font-size: 22px; .lang-en & { font-size: 18px; } }
  }

  // ========== Hero ==========
  .about-hero {
    position: relative;
    width: 100%;
    overflow: hidden;
    .hero-overlay {
      position: absolute; inset: 0; z-index: 1;
      background: linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.35) 100%);
    }
    .hero-bg { width: 100%; height: auto; display: block; }
    .hero-content {
      position: absolute; bottom: 12%; left: 0; right: 0; z-index: 2;
      text-align: center; padding: 0 20px;
      @media (max-width: 768px) { bottom: 8%; }
    }
    .hero-divider {
      width: 48px; height: 3px; background: #d53434;
      margin: 0 auto 16px; border-radius: 2px;
      @media (max-width: 768px) { width: 32px; margin-bottom: 10px; }
    }
    .hero-title {
      font-size: 44px; color: #fff; font-weight: 700;
      margin: 0 0 10px; letter-spacing: 2px;
      .lang-en & { font-size: 34px; }
      @media (max-width: 768px) { font-size: 28px; .lang-en & { font-size: 22px; } }
    }
    .hero-sub {
      font-size: 17px; color: rgba(255,255,255,0.8); margin: 0;
      .lang-en & { font-size: 14px; }
      @media (max-width: 768px) { font-size: 14px; .lang-en & { font-size: 12px; } }
    }
  }

  // ========== Intro ==========
  .intro-section {
    max-width: 1150px; width: 100%; padding: 80px 20px; margin: 0 auto;
    @media (max-width: 768px) { padding: 48px 20px; }
  }
  .intro-grid {
    display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center;
    @media (max-width: 900px) { grid-template-columns: 1fr; gap: 40px; }
  }
  .intro-text {
    .intro-p {
      text-align: left; font-size: 15px; line-height: 1.9; color: #555;
      margin: 0 0 18px;
      .lang-en & { font-size: 14px; line-height: 1.8; }
      @media (max-width: 768px) { font-size: 14px; }
    }
  }
  .intro-stats {
    display: grid; grid-template-columns: 1fr 1fr; gap: 20px;
    @media (max-width: 768px) { gap: 12px; }
  }
  .stat-card {
    background: #fff; border: 1px solid #eef0f3; border-radius: 14px;
    padding: 28px 16px; text-align: center;
    box-shadow: 0 2px 16px rgba(0,0,0,0.04);
    transition: transform 0.25s, box-shadow 0.25s;
    &:hover { transform: translateY(-4px); box-shadow: 0 8px 30px rgba(0,0,0,0.08); }
    @media (max-width: 768px) { padding: 20px 12px; }
    .stat-icon { font-size: 32px; display: block; margin-bottom: 8px; }
    .stat-value {
      display: block; font-size: 36px; font-weight: 800; color: #d53434; line-height: 1.2;
      .lang-en & { font-size: 30px; }
      @media (max-width: 768px) { font-size: 26px; .lang-en & { font-size: 22px; } }
    }
    .stat-label {
      display: block; font-size: 13px; color: #888; margin-top: 4px;
      .lang-en & { font-size: 11px; }
    }
  }

  // ========== Competencies ==========
  .competencies-section {
    background: #f8f9fc;
    padding: 80px 20px;
    @media (max-width: 768px) { padding: 48px 20px; }
  }
  .comp-grid {
    max-width: 1150px; width: 100%; margin: 40px auto 0;
    display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px;
    @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); gap: 16px; }
    @media (max-width: 500px) { grid-template-columns: 1fr; }
  }
  .comp-card {
    background: #fff; border-radius: 14px; padding: 32px 24px;
    text-align: left;
    border: 1px solid #eef0f3;
    box-shadow: 0 2px 12px rgba(0,0,0,0.03);
    transition: transform 0.25s, box-shadow 0.25s, border-color 0.25s;
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 30px rgba(0,0,0,0.08);
      border-color: #fcc;
    }
    .comp-icon { font-size: 36px; display: block; margin-bottom: 14px; }
    .comp-title { font-size: 18px; font-weight: 600; color: #1a1a1a; margin: 0 0 10px; .lang-en & { font-size: 15px; } }
    .comp-desc { font-size: 14px; color: #777; line-height: 1.7; margin: 0; .lang-en & { font-size: 12px; } }
  }

  // ========== Honors ==========
  .honors-section {
    max-width: 1150px; width: 100%; padding: 80px 20px 40px; margin: 0 auto;
    @media (max-width: 768px) { padding: 48px 20px 24px; }
  }
  .patent-banner {
    max-width: 1150px; width: 100%; margin: 40px auto 0; border-radius: 16px; overflow: hidden;
    box-shadow: 0 2px 20px rgba(0,0,0,0.06);
    img { width: 100%; height: auto; display: block; }
  }

  .cert-overlay-section {
    max-width: 1150px; width: 100%; padding: 0 20px 80px; margin: 0 auto;
    @media (max-width: 768px) { padding: 0 16px 48px; }
  }
  .gallery-title {
    text-align: center; font-size: 20px; color: #1a1a1a; margin: 0 0 32px;
    @media (max-width: 768px) { font-size: 17px; margin-bottom: 20px; }
  }
  .cert-overlay-wrapper {
    position: relative;
    width: 100%;
    border-radius: 16px; overflow: hidden;
    box-shadow: 0 4px 30px rgba(0,0,0,0.08);
  }
  .cert-bg {
    width: 100%; height: auto; display: block;
  }
  .cert-overlay-grid {
    position: absolute;
    top: 28%; left: 0;
    width: 100%;
    z-index: 1;

    @media (max-width: 1024px) { top: 25%; }
    @media (max-width: 768px) { top: 26%; }
  }
  .cert-row {
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin: 60px 0;

    @media (max-width: 1200px) { margin: 40px 0; }
    @media (max-width: 768px) { margin: 12px 0; }
  }
  .cert-item {
    width: 27%;
    border-radius: 10px; overflow: hidden; cursor: pointer;
    box-shadow: 0 4px 20px rgba(0,0,0,0.12);
    transition: transform 0.3s, box-shadow 0.3s;
    aspect-ratio: 3 / 4;
    &:hover { transform: scale(1.04); box-shadow: 0 8px 30px rgba(0,0,0,0.18); }
    @media (max-width: 768px) {
      width: 30%;
      aspect-ratio: 2 / 3;
    }
    .el-image { width: 100%; height: 100%; }
    ::v-deep .el-image__inner { object-fit: cover; }
    .cert-thumb {
      width: 100%; height: 100%; object-fit: cover; display: block;
    }
  }

  // ========== Certificate Lightbox ==========
  .cert-lightbox {
    position: fixed; inset: 0; z-index: 9999;
    display: flex; align-items: center; justify-content: center;
  }
  .cert-lightbox-mask {
    position: absolute; inset: 0;
    background: rgba(0,0,0,0.88);
  }
  .cert-lightbox-body {
    position: relative; z-index: 1;
    max-width: 90vw; max-height: 90vh;
    display: flex; align-items: center; justify-content: center;
  }
  .cert-lightbox-img {
    max-width: 90vw; max-height: 85vh;
    object-fit: contain; border-radius: 4px;
    box-shadow: 0 8px 40px rgba(0,0,0,0.5);
  }
  .cert-lightbox-close {
    position: fixed; top: 20px; right: 24px; z-index: 2;
    background: none; border: none; color: #fff; font-size: 32px;
    cursor: pointer; opacity: 0.7; transition: opacity 0.2s;
    &:hover { opacity: 1; }
  }
  .cert-lightbox-arrow {
    position: fixed; top: 50%; transform: translateY(-50%); z-index: 2;
    background: rgba(0,0,0,0.55); border: none; color: #fff;
    font-size: 48px; width: 56px; height: 80px; cursor: pointer;
    transition: background 0.2s;
    display: flex; align-items: center; justify-content: center;
    &:hover { background: rgba(0,0,0,0.75); }
    span { text-shadow: 0 1px 3px rgba(0,0,0,0.5); }
    @media (max-width: 768px) { font-size: 32px; width: 40px; height: 56px; }
  }
  .cert-lightbox-prev { left: 8px; border-radius: 0 8px 8px 0; }
  .cert-lightbox-next { right: 8px; border-radius: 8px 0 0 8px; }
  .cert-lightbox-counter {
    position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%);
    color: rgba(255,255,255,0.6); font-size: 14px; z-index: 2;
  }
}
</style>
